export default "__VITE_ASSET__BNJzmfOY__"